"use client";

import Script from "next/script";
import { use_lti_mode } from "@/auth/hooks/clerk-hooks";


export default function ConditionalCookieChimp() {
	const is_lti_mode = use_lti_mode();
	
	// Only load CookieChimp if NOT in an LTI session
	if (is_lti_mode) {
		return null;
	}

	return (
		<Script
			id="cookiechimp-js"
			src="https://cookiechimp.com/widget/JkgtKkm.js"
			strategy="afterInteractive"
		/>
	);
}
